<template>
  <div v-if="isMyAccount || !dummy">
    <TextLabel class="">{{ label }}</TextLabel>
    <div v-if="dummy" class="row">
      <div class="col">
        <!-- {{ dummy }} &nbsp; -->
        <template v-if="isMyAccount">
          <router-link
            :to="{
              name: $routerNames.EDIT,
              params: {
                ...account.params,
                ...$route.params,
              },
              hash: '#games-accounts-edit',
            }"
            >{{
              $t('_web_profile-info_games-add-link', 'Choose games')
            }}</router-link
          >
        </template>
      </div>
    </div>
    <transition-group
      v-else
      tag="div"
      class="row no-gutters favorite-games-wrapper"
      name="fade"
    >
      <div
        v-for="(game, index) in visibleAccountGames"
        :key="`${game}_${index}`"
        class="col-auto h-mr-4 mb-3"
      >
        <Avatar
          v-if="game"
          :size="36"
          :img-url="game.logo"
          :title="game.name"
        />
      </div>
      <div
        v-if="isCollapsible"
        key="favGamesExpandLink"
        class="col-12 d-flex justify-content-end"
      >
        <span
          class="font-size-sm cursor-hand text-link h-mr-4 purple"
          @click.prevent="toggleSeeAll"
        >
          {{ seeAllText }}
        </span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

// import Wrapper from '../../PanelWrapper';
import TextLabel from '@/components/atoms/TextLabel';
import Avatar from '@/components/images/Avatar';
export default {
  name: 'AccountInfoGames',
  components: {
    // Wrapper,
    Avatar,
    TextLabel,
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccountId: 'accountId' }),
    ...mapGetters(['gameByID']),
    accountGames() {
      return this.account.games.map(item => this.gameByID(item)) || [];
    },
    visibleAccountGames() {
      return this.showAll ? this.accountGames : this.accountGames.slice(0, 8);
    },
    seeAllText() {
      return this.showAll
        ? this.$t('_web_account_favorite-games-see-all-collapse', 'Collapse')
        : this.$t('_web_account_favorite-games-see-all', 'See All');
    },
    label() {
      return `${this.$t('_web_profile-info_games-header', `Games`, {
        name: this.account._name,
      })} (${this.accountGames.length})`;
    },
    isMyAccount() {
      return this.accountId === this.myAccountId;
    },
    dummy() {
      return !this.accountGames.length
        ? this.$t('_web_profile-info_no-games', 'No Games')
        : null;
    },
    isCollapsible() {
      return this.accountGames.length > 8;
    },
  },
  methods: {
    toggleSeeAll() {
      this.showAll = !this.showAll;
    },
  },
};
</script>
<style lang="scss">
.favorite-games-wrapper {
  max-width: 208px;
}
.purple {
  color: #5a58f2;
  &:hover {
    color: #5a58f2;
    opacity: 0.8;
  }
}
</style>
